import { YOO_FINDS_CDN } from "@/common";

export const YOOFINDS_LOGO_DALLAS = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/header/yoofinds-logo.webp`;

export const DALLAS_CREATOR_PICKS_TITLE = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/header/creator-picks-title.webp`;

export const FASSMOSS_LOGO_DALLAS = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/header/fassmoss-logo-v2.webp`;

export const BANNER_BG_DALLAS = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/banner/banner-bg-v3.webp`;

export const BANNER_TITLE_DALLAS = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/banner/banner-title.webp`;

export const ABOUT_US_TITLE_IMG = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/about-us/about-us-title.webp`;

export const ABOUT_US_LEFT_IMG = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/about-us/about-us-left-img.webp`;

export const DALLAS_MOUNTAIN = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/about-us/mountain.webp`;

export const SCHEDULE_HAT = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/schedule/hat.webp`;

export const SCHEDULE_TITLE = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/schedule/dallas-schedule.webp`;

export const SCHEDULE_CACTUS = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/schedule/cactus.webp`;

export const SCHEDULE_FREE_TICKETS = `${YOO_FINDS_CDN}/pc/la-2025/schedule/free-tickets.webp`;

export const SCHEDULE_SAWTOOTH = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/schedule/sawtooth.webp`;

export const PAST_EVENT_1 = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/past-event-1-v2.webp`;
export const PAST_EVENT_2 = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/past-event-2-v2.webp`;
export const PAST_EVENT_LEFT_STAR = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/left-star.webp`;
export const PAST_EVENT_RIGHT_STAR = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/right-star.webp`;
export const PAST_EVENT_YOOFINDS_LOGO = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/yoofinds-logo.webp`;
export const PAST_EVENT_FASSMOSS_LOGO = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/past-events/fassmoss-logo.webp`;

export const DALLAS_SIGN_UP_BANNER = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/tickets-page/tickets-banner-v2.webp`;
export const DALLAS_SIGN_UP_HAT = `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/tickets-page/hat.webp`;
export const UNFOLD =
  `${YOO_FINDS_CDN}/pc/creator-picks-2025-dallas/tickets-page/` + "unfold.svg";
